
module.exports = function(ads) {
    "use strict";
      ads
      .controller('adsSettingsController', adsSettingsController)
  
      adsSettingsController.$inject = ["$http","getDataService", "refreshtokenService","alertService","serverError", "API_URL","offlineError"];
      
    function adsSettingsController($http,getDataService,refreshtokenService, alertService,serverError, API_URL, offlineError) {
        var vmas = this;
        vmas.positions = [];
        vmas.save = function() {
            var data = {}
            vmas.positions.forEach(function(item){
              if(item.getItems) {
                data[item.id] = {}
                data[item.id]['items'] = item.getItems()
                data[item.id]['post_ids'] = item.post_ids
              }
            })
            data.midas_display = vmas.midas_display
            data.video_autoplay = vmas.video_autoplay
            var putFunction = function() {
                $http.put(API_URL + 'options/ads/settings' , data)
                .success(function (data, status, headers) {
                    alertService('success','Success ', data.message, 2000);
                })
                .error(function (data, status, header, config) {
                  if(!window.navigator.onLine) {
                    offlineError()
                    alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                    return
                  }
                  if(status ==401) {
                    var promise = refreshtokenService.getAccessToken();
                    promise.then(
                      function(answer) {
                        if(answer==200) {   
                          putFunction();
                        }
                      },
                      function(error) {
                        // report something
                      },
                      function(progress) {
                       // report progress
                    });
                  }else if(status ==502) {
                    serverError();
                  } else {  
                    alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
                  }
                });
            }
            putFunction();
        }
        var getAdsSettings = function() {
            getDataService.get({
              param1: 'options',
              param2: 'ads',
              param3: 'settings'
              }).$promise.then(function(data){
                if(data.positions && data.positions.length>0) {
                  vmas.positions = data.positions
                }
                vmas.video_autoplay = data.video_autoplay
                vmas.midas_display = data.midas_display
            }, function(error){
              if(!window.navigator.onLine) {
                offlineError('refresh')
                return
              }
              if(error.status ==401) {
                var promise = refreshtokenService.getAccessToken();
                promise.then(
                  function(answer) {
                    if(answer==200) {
                      getAdsSettings();
                    }
                    // do something
                  },
                  function(error) {
                  },
                  function(progress) {
                   // report progress
                  });
              } else if(error.status ==502) {
                  serverError()
              } else {
                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
              }
              
            });
        }
        var getCategoriesFunction = function() {
            getDataService.get({param1:'categories', param2: null, tree:1, src:'adosettings'}).$promise.then(function(data){      
              vmas.categories = data.categories;
              getAdsSettings()
            }, function(error){
              if(!window.navigator.onLine) {
                offlineError()
                return
              }
              if(error.status == 401) {
                var promise = refreshtokenService.getAccessToken();
                  promise.then(
                    function(answer) {
                      if(answer==200) {
                        getCategoriesFunction();
                      }
                    },
                    function(error) {
                      // report something
                    },
                    function(progress) {
                     // report progress
                    });
              } else if(error.status ==502) {
                serverError()
              }
            });
        }
        getCategoriesFunction();
    } 
  }


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/adsModule/settings/js/adsSettingsController.js
// module id = 481
// module chunks = 0